<div class="alert-warning text-center" style="margin-bottom: 3rem;" *ngIf="!isBankVerificationApiAvailable">
    <div style="font-size: 1.625rem;">Bank verification service is temporarily unavailable, we'll need to verify the details later. Please enter the bank details and continue with the purchase. </div>
</div>